import fetch from 'auth/FetchInterceptor'

const SettingsService = {}
const ServiceURL = "/settings"

SettingsService.get = function () {
    return fetch({
        url: ServiceURL + '/get',
        method: 'get',
    })
}


SettingsService.byName = function (name) {
    return fetch({
        url: '/settings/get/' + name,
        method: 'get',
    })
}

SettingsService.modify = function (data) {
    return fetch({
        url: ServiceURL + '/modify',
        method: 'post',
        data: data
    })
}

SettingsService.getLanguages = function () {
    return {
        queryKey: ['get_all_languages'],
        queryFn: () => fetch({
            url: ServiceURL + '/do_action',
            method: 'post',
            data: {
                action: 'get_languages'
            }
        })
    }
}

SettingsService.getLanguageKeys = function (id) {
    return {
        queryKey: ['get_language_keys', id],
        queryFn: () => fetch({
            url: ServiceURL + '/do_action',
            method: 'post',
            data: {
                action: 'get_language_keys',
                languageId: id
            }
        })
    }
}

SettingsService.addNewLanguage = function (data) {
    data.action = 'add_language';
    return fetch({
        url: ServiceURL + '/do_action',
        method: 'post',
        data: data
    })
}

SettingsService.updateLanguageKeys = function (data) {
    data.action = 'update_language_keys';
    return fetch({
        url: ServiceURL + '/do_action',
        method: 'post',
        data: data
    })
}

SettingsService.updateLanguage = function (data) {
    data.action = 'update_language';
    return fetch({
        url: ServiceURL + '/do_action',
        method: 'post',
        data: data
    })
}
SettingsService.addNewLanguageKey = function (data) {
    data.action = 'add_language_key';
    return fetch({
        url: ServiceURL + '/do_action',
        method: 'post',
        data: data
    })
}

SettingsService.uploadLanguageFile = function (fileData) {
    var data = {
        action: "upload_language_file",
        fileData
    }
    return fetch({
        url: ServiceURL + "/do_action",
        method: "Post",
        data: data
    });
};

SettingsService.addNewCurrency = function (data) {
    data.action = 'add_currency';
    return fetch({
        url: ServiceURL + '/do_action',
        method: 'post',
        data: data
    })
}

SettingsService.getCurrencies = function (isoCode) {
    return {
        queryKey: ['get_all_currencies', isoCode],
        queryFn: () => fetch({
            url: ServiceURL + '/do_action',
            method: 'post',
            data: {
                action: 'get_currencies',
                isoCode: isoCode
            }
        })
    }
}

SettingsService.updateCurrency = function (data) {
    data.action = 'update_currency';
    return fetch({
        url: ServiceURL + '/do_action',
        method: 'post',
        data: data
    })
}


export default SettingsService
